import { CourseMaterial, useCoursesLoaderData } from "../coursesLoader";
import useMaterialOptDeadline from "../useMaterialOptDeadline";
import useOptedIn from "../useOptedIn";
import { useIntl } from "react-intl";

export default function useMaterialPrice(courseMaterial: CourseMaterial) {
  const { currentTerm } = useCoursesLoaderData();
  const programDecision = currentTerm?.programDecision;
  const optedIn = useOptedIn(courseMaterial);
  const { optWindowOpen } = useMaterialOptDeadline(courseMaterial);
  const { verbaLicense, studentPrice, currency } = courseMaterial;
  const intl = useIntl();

  const includesTax =
    verbaLicense &&
    verbaLicense.salesTaxEnabled &&
    !verbaLicense.salesTaxExempt &&
    verbaLicense.studentPriceWithTax > 0;

  const price = includesTax ? verbaLicense.studentPriceWithTax : studentPrice;
  const taxMessage = intl.formatMessage({ defaultMessage: "(includes tax)" });

  if (
    programDecision === "inclusive_access" &&
    optWindowOpen &&
    optedIn &&
    !verbaLicense?.hidePrice &&
    currency &&
    !!price
  ) {
    return `${intl.formatNumber(price, { style: "currency", currency })} ${
      includesTax ? taxMessage : ""
    }`.trim();
  }
  return null;
}
